/**
 * Service para Painel Operacional
 * Gerencia comunicação com API para operações administrativas
 */

import api from './api';

/**
 * Listar usuários para painel operacional
 */
export const listarUsuariosOperacional = async (params = {}) => {
  try {
    const { page = 1, limit = 12, search = '' } = params;
    const response = await api.get('/operacional/usuarios', {
      params: { page, limit, search }
    });
    return response;
  } catch (error) {
    console.error('Erro ao listar usuários operacional:', error);
    throw error;
  }
};

/**
 * Obter perfil completo de um usuário
 */
export const getPerfilCompleto = async (userId) => {
  try {
    const response = await api.get(`/operacional/usuarios/${userId}/perfil`);
    return response;
  } catch (error) {
    console.error('Erro ao buscar perfil completo:', error);
    throw error;
  }
};

/**
 * Upload de documento para um usuário
 */
export const uploadDocumento = async (userId, formData) => {
  try {
    const response = await api.post(`/operacional/usuarios/${userId}/documentos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    console.error('Erro ao fazer upload de documento:', error);
    throw error;
  }
};

/**
 * Listar documentos de um usuário
 */
export const listarDocumentosUsuario = async (userId, tipo = '') => {
  try {
    const response = await api.get(`/operacional/usuarios/${userId}/documentos`, {
      params: { tipo }
    });
    return response;
  } catch (error) {
    console.error('Erro ao listar documentos:', error);
    throw error;
  }
};

/**
 * Download de documento
 */
export const downloadDocumento = async (documentoId) => {
  try {
    const response = await api.get(`/operacional/documentos/${documentoId}/download`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error('Erro ao fazer download do documento:', error);
    throw error;
  }
};

/**
 * Deletar documento
 */
export const deletarDocumento = async (documentoId) => {
  try {
    const response = await api.delete(`/operacional/documentos/${documentoId}`);
    return response;
  } catch (error) {
    console.error('Erro ao deletar documento:', error);
    throw error;
  }
};

const operacionalService = {
  listarUsuariosOperacional,
  getPerfilCompleto,
  uploadDocumento,
  listarDocumentosUsuario,
  downloadDocumento,
  deletarDocumento
};

export default operacionalService;
